<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar }
    ]"
  >
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu></user-menu>
      <mobile-menu></mobile-menu>
      <template slot="links">
        <sidebar-item
          :link="{ name: 'Strona główna', image: homeIcon, path: '/dashboard' }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Urządzenia',
            icon: 'devices',
            path: '/devices/list-devices'
          }"
        />

        <sidebar-item
          :link="{
            name: 'Kasy fiskalne',
            image: cashRegistersIcon,
            path: '/cash-registers/list-cash-registers'
          }"
        />

        <!-- Ukryte od wersji 1.0.2     v-if="appUrl !== 'https://pk-test.posnet.com'"      -->
        <!-- <sidebar-item
          :link="{
            name: 'Licencje',
            icon: 'payments',
            path: '/licences/list-licences'
          }"
        /> -->
        
        <sidebar-item v-if="roles.includes('admin')"
          :link="{
            name: 'Kontrahenci',
            image: customersIcon,
            path: '/customers/list-customers'
          }"
        />

        <sidebar-item
          :link="{
            name: 'Lokalizacje',
            image: locationsIcon,
            path: '/locations/list-locations'
          }"
        />
        <sidebar-item
          :link="{
            name: 'BLIK',
            image: blikLogo,
            path: '/blik'
          }"
        />

        <!-- <sidebar-item
          :link="{
            name: 'BLIK Blue Media',
            image: blikLogo,
            path: '/blik-bm'
          }"
        /> -->

        <!-- <sidebar-item v-if="roles.includes('admin')" opened :link="{ name: 'Zarządzanie', icon: 'apps' }">
          <sidebar-item
            :link="{
              name: 'Osoby',
              icon: 'person',
              path: '/people/list-people'
            }"
          />
          <sidebar-item
            :link="{
              name: 'Użytkownicy',
              icon: 'account_box',
              path: '/examples/user-management/list-users'
            }"
          />
          <sidebar-item
            :link="{
              name: 'Kontakty',
              icon: 'contact_phone',
              path: '/contacts/list-contacts'
            }"
          />
        </sidebar-item> -->

        <sidebar-item v-if="permissions && (
              permissions.includes('replace device component') || 
              permissions.includes('create device firmware versions') || 
              permissions.includes('create device model firmware versions') || 
              permissions.includes('create services')
              )" :link="{ name: 'Administracja', icon: 'tune' }">
          <sidebar-item v-if="permissions.includes('replace device component')" :link="{ name: 'Wymiana serwisowa', path: '/administration/terminal-replacement' }" />
          <sidebar-item v-if="permissions.includes('create device model firmware versions')" :link="{ name: 'Modele urządzeń', path: '/device-models/list-device-models' }" />
          <sidebar-item v-if="permissions.includes('create device firmware versions')" :link="{ name: 'Firmware urządzenia', path: '/device-firmware-versions/list-device-firmware-versions' }" />
          <sidebar-item v-if="permissions.includes('create device model firmware versions')" :link="{ name: 'Firmware modele', path: '/device-model-firmware-versions/list-device-model-firmware-versions' }" />
          <sidebar-item v-if="permissions.includes('create services')" :link="{ name: 'Usługi', path: '/services/list-services' }" />
          <sidebar-item v-if="permissions.includes('create services')" :link="{ name: 'Usługi Kasy fiskalne', path: '/administration/cash-register-services' }" />
          <sidebar-item v-if="permissions.includes('manage personal tokens')" :link="{ name: 'Tokeny osobiste', path: '/oauth/personal-tokens' }" />
        </sidebar-item>

        <!-- <sidebar-item v-if="roles" :link="{ name: 'Examples (API)', image: image }">
          <sidebar-item
            v-if="roles.includes('admin')"
            :link="{
              name: 'Role Management',
              path: '/examples/role-management/list-roles'
            }"
          />
          <sidebar-item
            v-if="roles.includes('admin')"
            :link="{
              name: 'User Management',
              path: '/examples/user-management/list-users'
            }"
          />
          <sidebar-item
            v-if="roles.includes('admin') || roles.includes('creator')"
            :link="{
              name: 'Category Management',
              path: '/examples/category-management/list-categories'
            }"
          />
          <sidebar-item
            v-if="roles.includes('admin') || roles.includes('creator')"
            :link="{
              name: 'Tag Management',
              path: '/examples/tag-management/list-tags'
            }"
          />
          <sidebar-item
            :link="{
              name: 'Item Management',
              path: '/examples/item-management/list-items'
            }"
          />
        </sidebar-item> -->
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <!-- <fixed-plugin
        :color.sync="sidebarBackground"
        :colorBg.sync="sidebarBackgroundColor"
        :sidebarMini.sync="sidebarMini"
        :sidebarImg.sync="sidebarImg"
        :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin> -->

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view/>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
// import FixedPlugin from "../../FixedPlugin.vue";
import UserMenu from "./Extra/UserMenu.vue";
import Vuex from 'vuex';
import SidebarItem from '../../../components/SidebarPlugin/SidebarItem.vue';

export default {
  components: {
    TopNavbar,
    ContentFooter,
    // FixedPlugin,
    MobileMenu,
    UserMenu,
    SidebarItem
  },
  data() {
    return {
      sidebarBackgroundColor: "navy-blue",
      sidebarBackground: "grey",
      // sidebarBackgroundImage: process.env.VUE_APP_BASE_URL + "/img/sidebar-2.jpg",
      sidebarBackgroundImage: "",
      sidebarMini: false,
      sidebarImg: true,
      image: process.env.VUE_APP_BASE_URL + '/img/laravel-vue.svg',
      blikLogo: process.env.VUE_APP_BASE_URL + '/img/icons/menu/blik.svg',
      cashRegistersIcon: process.env.VUE_APP_BASE_URL + '/img/icons/menu/cash-registers.svg',
      customersIcon: process.env.VUE_APP_BASE_URL + '/img/icons/menu/customers.svg',
      homeIcon: process.env.VUE_APP_BASE_URL + '/img/icons/menu/home.svg',
      locationsIcon: process.env.VUE_APP_BASE_URL + '/img/icons/menu/locations.svg',
      roles: [],
      permissions: [],
      appUrl: process.env.VUE_APP_BASE_URL
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
  },
  computed: {
    ...Vuex.mapState({
      me: state => state.profile.me
    })
  },
  watch: {
    me: {
      handler: function(val) {
        if (val.roles) {
          this.roles = val.roles.map(r => r.name)
        }
        this.permissions = val.permissions
      },
      deep: true
    },
    sidebarMini() {
      this.minimizeSidebar();
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
